import React, { useEffect } from 'react';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import { useContext as useUsersContext } from 'components/Users/Context';

import TrainingSteps from './Views/TrainingSteps/Index';
import WaitingForApproval from './Views/WaitingForApproval/Index';
import RequestingTraining from './Views/RequestingTraining/Index';

export default function Main() {
  const { dispatch: dispatchUsers, actions: actionsUsers, state: stateUsers } = useUsersContext();

  useEffect(() => {
    actionsUsers.load(dispatchUsers);
  }, []);

  if (stateUsers.user === null) {
    return (
      <div className="content">
        <section>
          <LoadingPlaceholder text="Loading..." />
        </section>
      </div>
    );
  }

  const affiliate = stateUsers.user.attributes.specific;

  if (affiliate.training_approved_at) {
    return <TrainingSteps />;
  }

  if (affiliate.training_requested_at) {
    return <WaitingForApproval />;
  }

  return <RequestingTraining />;
}
